import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { string } from 'prop-types';
import { useSelector } from 'react-redux';
import Search from './containers/Search';
import JobDetails from './containers/JobDetails';
import JobApplication from './containers/JobApplication';
import './style.module.scss';

const Router = ({ baseRoute }) => {
  const isVersion2 = useSelector((state) => state.app.isVersion2);
  const supportsHistory = 'pushState' in window.history;

  return (
    <BrowserRouter basename={baseRoute} forceRefresh={!supportsHistory}>
      <Routes>
        <Route exact path="/" element={<Search />} />
        <Route exact path="/job/:slug" element={<JobDetails />} />
        {isVersion2 && <Route exact path="/job/apply/:jobId" element={<JobApplication />} />}
      </Routes>
    </BrowserRouter>
  );
};

Router.propTypes = {
  baseRoute: string.isRequired,
};

export default Router;
